/** @jsxImportSource @emotion/react */
'use client'

import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { FlexCol, FlexRow } from '../layout'
import StatCardShell from './StatCardShell'
import { styles } from './styles'

export interface PricingStatCardProps {
  /** Fired when the "What our bots do" link is clicked. */
  onLearnMore?: () => void
}

/**
 * Pricing / offering stat — pay-per-use with no setup costs, five live AI
 * workflows. Footer links out to the full workflow list.
 */
export default function PricingStatCard({ onLearnMore }: PricingStatCardProps) {
  return (
    <StatCardShell
      kicker="How it works"
      tone="light"
      footer={
        <FlexRow justify="between" css={styles.headerRow}>
          <Typography component="span" css={[styles.subLabel]}>
            Call auditing · Claims scoring · Pending review · File audits · Loss
            of use
          </Typography>
          {onLearnMore && (
            <Link
              component="button"
              type="button"
              onClick={onLearnMore}
              css={styles.link}
            >
              What our bots do →
            </Link>
          )}
        </FlexRow>
      }
    >
      <FlexCol gap="sm">
        <Typography component="p" css={[styles.metricSm, styles.headingFont]}>
          Pay-per-use. No setup costs.
        </Typography>
        <Typography
          component="p"
          css={[styles.description, styles.descriptionTone.light]}
        >
          Five AI workflows, live now. Spin up only what you need.
        </Typography>
      </FlexCol>
    </StatCardShell>
  )
}
